// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1y2lm","item":"PaymentsMobile_item__eEIAR","label":"PaymentsMobile_label__34n4x","amount":"PaymentsMobile_amount__2vkhC"};